import Panel from 'portaltransparencia-common/components/Panel.react.js';
import { getAllValuesFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import { PARAM_EXIBE_GASTOS_TOTAIS } from 'portaltransparencia-common/parametros/ParametrosPortalTransparencia';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import { downloadArquivo } from '../arquivo/Actions.js';
import Arquivo from '../arquivo/Arquivo.react.js';
import PageHeader from '../components/PageHeader.react.js';
import ParametroService from '../parametros/ParametroService.js';
import * as actions from './Actions.js';
import DiariaDetalheInformacao from './DiariaDetalheInformacao.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import Tab from 'portaltransparencia-common/components/Tab.react.js';

export function isValidIdEmpenho(idEmpenho) {
  return (
    idEmpenho !== undefined &&
    idEmpenho !== null &&
    idEmpenho !== '' &&
    idEmpenho !== 'undefined'
  );
}

export class FormDiariaDetail extends Component {
  static propTypes = {
    diaria: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    findDiaria: PropTypes.func.isRequired,
    arquivos: PropTypes.object.isRequired,
    arquivosPrestacaoConta: PropTypes.object.isRequired,
    findArquivos: PropTypes.func.isRequired,
    findArquivosPrestacaoConta: PropTypes.func.isRequired,
    paramMostrarGastosTotais: PropTypes.string.isRequired,
    isIntegradoOxy: PropTypes.bool
  };

  componentDidMount() {
    const {
      location,
      findDiaria,
      findArquivos,
      findArquivosPrestacaoConta
    } = this.props;

    const params = getAllValuesFromUrlSearchParams(location);

    findDiaria(
      params.entidade,
      params.exercicio,
      params.empenho,
      params.noLiquidacao,
      params.unidadeOrcamentaria
    );
    findArquivos(
      params.entidade,
      params.exercicio,
      params.empenho,
      params.noLiquidacao
    );

    if (isValidIdEmpenho(params.idEmpenho)) {
      findArquivosPrestacaoConta(params.idEmpenho);
    }
  }

  render() {
    const {
      diaria,
      downloadArquivo,
      arquivos,
      arquivosPrestacaoConta,
      paramMostrarGastosTotais,
      isIntegradoOxy
    } = this.props;

    return (
      <div>
        <Helmet title={`Diárias - ${diaria.get('nome')}`} />

        <PageHeader
          location={this.props.location}
          textoDetalhe={`Diária: ${diaria.get('empenho')}/${diaria.get(
            'exercicio'
          )} - ${diaria.get('nome')}`}
        />

        <DiariaDetalheInformacao
          diaria={diaria}
          mostrarGastosTotais={paramMostrarGastosTotais === 'S'}
        />

        <Panel isTable tableResponsive expansible={false}>
          <Tabs id="tabs">
            <Tab
              onlyTable
              tableResponsive
              id="diarias"
              title="Anexos Diárias"
              active={true}
            >
              <Arquivo arquivos={arquivos} onDownload={downloadArquivo} />
            </Tab>
            {isIntegradoOxy && (
              <Tab
                onlyTable
                tableResponsive
                id="prestacao-de-contas"
                title="Anexos Prestação de Contas"
              >
                <Arquivo
                  arquivos={arquivosPrestacaoConta}
                  onDownload={downloadArquivo}
                />
              </Tab>
            )}
          </Tabs>
        </Panel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    diaria: state.diaria.get('diaria'),
    arquivos: state.diaria.get('arquivos'),
    arquivosPrestacaoConta: state.diaria.get('arquivosPrestacaoConta'),
    paramMostrarGastosTotais: ParametroService.getValorParametro(
      state,
      PARAM_EXIBE_GASTOS_TOTAIS
    ),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ])
  };
}

const allActions = {
  ...actions,
  downloadArquivo
};

export default connect(mapStateToProps, allActions)(FormDiariaDetail);
